var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "watchlist-add-dialog" } },
    [
      _c(
        "q-stepper",
        {
          ref: "stepper",
          attrs: {
            vertical: "",
            color: "primary",
            animated: "",
            "keep-alive": "",
            "header-nav": !_vm.disableSave
          },
          model: {
            value: _vm.step,
            callback: function($$v) {
              _vm.step = $$v
            },
            expression: "step"
          }
        },
        [
          _c(
            "q-step",
            {
              attrs: {
                name: 1,
                title: _vm.$t("addToWatchlist.step.1"),
                done: _vm.step > 1
              }
            },
            [
              _c("div", { staticClass: "column" }, [
                _vm.user.zohoAuthenticated
                  ? _c(
                      "div",
                      { staticClass: "col" },
                      [
                        _c("customer-select", {
                          attrs: { "customer-name": _vm.presetCustomerName },
                          model: {
                            value: _vm.selectedCustomer,
                            callback: function($$v) {
                              _vm.selectedCustomer = $$v
                            },
                            expression: "selectedCustomer"
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col" },
                  [
                    _c("watchlist-select", {
                      attrs: {
                        "watchlist-name": _vm.presetWatchlistName,
                        customer: _vm.selectedCustomer,
                        disable:
                          _vm.user.zohoAuthenticated && !_vm.selectedCustomer,
                        "only-static": ""
                      },
                      model: {
                        value: _vm.selectedWatchlist,
                        callback: function($$v) {
                          _vm.selectedWatchlist = $$v
                        },
                        expression: "selectedWatchlist"
                      }
                    })
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c(
                "q-stepper-navigation",
                [
                  _c("q-btn", {
                    attrs: {
                      label: _vm.$t("continue"),
                      color: "primary",
                      disable: _vm.disableSave,
                      "no-caps": ""
                    },
                    on: {
                      click: function($event) {
                        return _vm.$refs.stepper.next()
                      }
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "q-step",
            {
              attrs: {
                name: 2,
                title: _vm.$t("addToWatchlist.step.2"),
                done: _vm.step > 2
              }
            },
            [
              _c("div", { staticClass: "column" }, [
                _c(
                  "div",
                  { staticClass: "col" },
                  [
                    _c("q-input", {
                      attrs: {
                        type: "number",
                        loading: _vm.loading,
                        prefix: _vm.$t("label.price"),
                        suffix: _vm.priceUnit,
                        "input-class": "text-right"
                      },
                      model: {
                        value: _vm.newPrice,
                        callback: function($$v) {
                          _vm.newPrice = $$v
                        },
                        expression: "newPrice"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col" },
                  [
                    _c("q-input", {
                      attrs: {
                        placeholder: _vm.$t("addDescription"),
                        disabled: _vm.loading,
                        label: _vm.$t("label.comment"),
                        autogrow: ""
                      },
                      model: {
                        value: _vm.newDescription,
                        callback: function($$v) {
                          _vm.newDescription = $$v
                        },
                        expression: "newDescription"
                      }
                    })
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c(
                "q-stepper-navigation",
                [
                  _c("q-btn", {
                    attrs: {
                      label: _vm.$t("continue"),
                      color: "primary",
                      "no-caps": ""
                    },
                    on: {
                      click: function($event) {
                        return _vm.$refs.stepper.next()
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("q-btn", {
                    attrs: {
                      label: _vm.$t("previous"),
                      flat: "",
                      "no-caps": ""
                    },
                    on: {
                      click: function($event) {
                        return _vm.$refs.stepper.previous()
                      }
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "q-step",
            {
              attrs: {
                name: 3,
                title: _vm.$t("addToWatchlist.step.3"),
                done: _vm.step > 3
              }
            },
            [
              _c("q-toggle", {
                attrs: {
                  label: _vm.$t("label.showBundleImages"),
                  disable: _vm.disableSave
                },
                model: {
                  value: _vm.showBundleImages,
                  callback: function($$v) {
                    _vm.showBundleImages = $$v
                  },
                  expression: "showBundleImages"
                }
              }),
              _vm._v(" "),
              _c("bundle-viewer", {
                staticClass: "q-my-sm",
                attrs: { log: _vm.objectToAdd, height: 200 }
              }),
              _vm._v(" "),
              _c("log-images-picker", {
                attrs: { props: _vm.logImagesPickerProps, emit: "" },
                on: { "change-teaser": _vm.changeTeaser },
                model: {
                  value: _vm.excludedImages,
                  callback: function($$v) {
                    _vm.excludedImages = $$v
                  },
                  expression: "excludedImages"
                }
              }),
              _vm._v(" "),
              _c(
                "q-stepper-navigation",
                [
                  _c("q-btn", {
                    attrs: {
                      label: _vm.$t("previous"),
                      color: "secondary",
                      "no-caps": ""
                    },
                    on: {
                      click: function($event) {
                        return _vm.$refs.stepper.previous()
                      }
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "row q-mt-md justify-end" }, [
        _c(
          "div",
          [
            _c("q-btn", {
              attrs: { label: _vm.$t("button.cancel"), flat: "" },
              on: { click: _vm.cancel }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          [
            _c("q-btn", {
              attrs: {
                label: _vm.$t("button.watch"),
                loading: _vm.loading,
                disable: _vm.disableSave,
                color: "primary"
              },
              on: { click: _vm.save }
            })
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "row q-mt-md" },
        [
          !_vm.checkedActiveWatchlists
            ? _c(
                "span",
                { staticClass: "text-primary" },
                [
                  _vm._v(_vm._s(_vm.$t("checkingActiveWatchlists")) + " "),
                  _c("q-spinner-dots", { attrs: { color: "primary" } })
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.activeWatchlists.length
            ? _c("q-table", {
                staticClass: "activeWatchlistsTable",
                attrs: {
                  title: _vm.$t("activeWatchlistsTableTitle"),
                  data: _vm.activeWatchlists,
                  columns: _vm.activeWatchlistsColumns,
                  "row-key": "uid",
                  "hide-bottom": ""
                }
              })
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }